import React from 'react';
import PropTypes from 'prop-types';
import {BringForward, BringToFront, SendBackward, SendToBack} from "Components/Icons";

export default class Arrangement extends React.Component
{
    static propTypes = {
        bringElementForward: PropTypes.func.isRequired,
        sendElementBackward: PropTypes.func.isRequired,
        bringElementToFront: PropTypes.func.isRequired,
        sendElementToBack: PropTypes.func.isRequired,
    };

    render()
    {
        return <>
            <button className='p-2 rounded hover:bg-gray-100' onClick={this.props.bringElementForward} title='Bring Forwards'>
                <BringForward className='text-black w-4' />
            </button>

            <button className='p-2 rounded hover:bg-gray-100' onClick={this.props.bringElementToFront} title='Bring to Front'>
                <BringToFront className='text-black w-4' />
            </button>

            <button className='p-2 rounded hover:bg-gray-100' onClick={this.props.sendElementBackward} title='Send Backwards'>
                <SendBackward className='text-black w-4' />
            </button>

            <button className='p-2 rounded hover:bg-gray-100' onClick={this.props.sendElementToBack} title='Send to Back'>
                <SendToBack className='text-black w-4' />
            </button>
        </>;
    }
}
